import { injectFragments } from "./headerFooter";

export const bootstrapHeaderFooter = ({
  language,
  baseURL,
}: {
  language: string;
  baseURL: string;
}) => {
  return Promise.all([
    injectFragments(`${baseURL}/${language}/fantasy/header-ism`, [
      {
        fetchSelector: "header",
        currentSelector: "body > header",
      },
    ]),
    injectFragments(`${baseURL}/${language}/fantasy/footer-ism`, [
      {
        fetchSelector: "footer",
        currentSelector: "body > main > footer",
      },
    ]),
  ]).then(() => {
    // Activate in order: dynamic-import first (sets window.supportsDynamicImport),
    // then the SystemJS fallback which reads that flag.
    ["ism-script-import-dynamic", "ism-script-import"].forEach((id) => {
      const el = document.getElementById(id);
      if (el) {
        const script = document.createElement("script");
        script.textContent = el.textContent;
        document.head.appendChild(script);
      }
    });
  });
};
